import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable, map } from "rxjs";
import {
	type CreateOpenHouseInput,
	type OpenHouse,
	type UpdateOpenHouseInput,
} from "src/app/schema";
import { ApiService } from "src/app/services";

@Injectable({
	providedIn: "root",
})
export class OpenHouseService {
	private readonly _api = inject(ApiService);
	private readonly _httpClient = inject(HttpClient);

	public createOpenHouse(
		openHouse: CreateOpenHouseInput,
	): Observable<OpenHouse> {
		return this._httpClient.post<OpenHouse>(
			`${this._api.inventoryApiEndpoint}/openhouse`,
			openHouse,
		);
	}

	public updateOpenHouse(
		openHouse: UpdateOpenHouseInput,
	): Observable<OpenHouse> {
		return this._httpClient.put<OpenHouse>(
			`${this._api.inventoryApiEndpoint}/openhouse`,
			openHouse,
		);
	}

	public deleteOpenHouse(openHouse: OpenHouse): Observable<void> {
		return this._httpClient
			.delete<{ id: string }>(
				`${this._api.inventoryApiEndpoint}/openhouse/${openHouse.id}`,
			)
			.pipe(map(() => {}));
	}
}
